import { createContext, useCallback, useContext, useEffect, useState } from 'react';
import { NotificationService } from '../services/NotificationService';

const NotificationContext = createContext();

const compareNotifications = (a, b) => {
  // 1. Priority: Blocking (requiereAceptacion) first
  // Note: requiereAceptacion is inside 'datos' object
  const isBlockingA = a.datos?.requiereAceptacion ?? false;
  const isBlockingB = b.datos?.requiereAceptacion ?? false;

  if (isBlockingA && !isBlockingB) return -1; // a comes first
  if (!isBlockingA && isBlockingB) return 1;  // b comes first

  // 2. Secondary: Date (Oldest first)
  if (a.fechanotificacion > b.fechanotificacion) return 1;
  if (a.fechanotificacion < b.fechanotificacion) return -1;
  return 0;
};

export const NotificationContextProvider = ({ children }) => {
  const [allNotifications, setAllNotifications] = useState();
  const [pendingNotifications, setPendingNotifications] = useState([]);
  const [readNotifications, setReadNotifications] = useState([]);
  const [loading, setLoading] = useState(true);

  const loadNotifications = useCallback(async () => {
    setLoading(true);
    try {
      const notifications = await NotificationService.getAll()
      setAllNotifications(notifications.sort(compareNotifications));
    } finally {
      setLoading(false);
    }
  }, []);

  const changeReadStatus = useCallback(async (notificationId, readState) => {
    await NotificationService.changeReadStatus(notificationId, readState);
    await loadNotifications();
  }, [loadNotifications]);

  const acceptNotification = useCallback(async (notificationId) => {
    await NotificationService.acceptNotification(notificationId);
    await loadNotifications();
  }, [loadNotifications]);

  useEffect(() => {
    if (allNotifications) {
      setPendingNotifications(allNotifications?.filter(it => it.notificacionleida === false));
      setReadNotifications(allNotifications?.filter(it => it.notificacionleida === true));
    }
  }, [allNotifications]);

  // Load notifications on component mount
  useEffect(() => {
    loadNotifications();
  }, [loadNotifications]);

  return (
    <NotificationContext.Provider value={{
      allNotifications,
      pendingNotifications,
      readNotifications,
      loading,
      loadNotifications,
      changeReadStatus,
      acceptNotification,
    }}>
      {children}
    </NotificationContext.Provider>
  );
};

export const useNotificationContext = () => useContext(NotificationContext);
